import * as Yup from 'yup';
import { DictionaryLegalForm } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryLegalForm>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
